import Layout from '@/views/layout'
import MultilevelRouting from '@/components/multilevelRouting'
export default {
  path: '/system',
  menuName: '系统设置',
  component: Layout,
  redirect: 'noredirect',
  name: 'system',
  meta: { title: 'system', icon: 'icon-system', iconType: 'svg' },
  children: [
    {
      path: 'user',
      name: 'user',
      menuName: '用户管理',
      component: () => import('@/views/system/user'),
      meta: { title: 'user', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'menus',
      name: 'menus',
      menuName: '菜单管理',
      component: () => import('@/views/system/menuManager'),
      meta: { title: 'menu' }
    },
    {
      path: 'role',
      name: 'role',
      menuName: '角色管理',
      component: () => import('@/views/system/role'),
      meta: { title: 'role', icon: 'role', iconType: 'svg' }
    },
    {
      path: 'log',
      name: 'logs',
      menuName: '日志管理',
      component: MultilevelRouting,
      meta: { title: 'log', icon: 'log', iconType: 'svg' },
      children: [
        {
          path: 'log/loginlogs',
          name: 'loginlogs',
          menuName: '登录日志',
          component: () => import('@/views/system/logs/logins/index'),
          meta: { title: 'carauthorize' }
        },
        {
          path: 'log/operlogs',
          name: 'operlogs',
          menuName: '操作日志',
          component: () => import('@/views/system/logs/oper/index'),
          meta: { title: 'carauthorize' }
        }
      ]
    },
    {
      path: 'company',
      name: 'company',
      menuName: '企业管理',
      component: () => import('@/views/system/company'),
      meta: { title: 'company', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'subCompany',
      name: 'subCompany',
      menuName: '经销商管理',
      component: () => import('@/views/system/subCompany'),
      meta: { title: 'subCompany', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'vehicle',
      name: 'vehicle',
      menuName: '车辆管理',
      component: () => import('@/views/system/vehicle'),
      meta: { title: 'vehicle', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'channel',
      name: 'channel',
      menuName: '渠道商管理',
      component: () => import('@/views/system/channel'),
      meta: { title: 'channel', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'department',
      name: 'department',
      menuName: '门店管理',
      component: () => import('@/views/system/department'),
      meta: { title: 'department', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'brand',
      name: 'brand',
      menuName: '品牌管理',
      component: () => import('@/views/system/brand'),
      meta: { title: 'brand', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'repairManage',
      name: 'repairManage',
      menuName: '维修管理',
      component: () => import('@/views/system/repairManage'),
      meta: { title: 'repairManage', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'maintenanceManage',
      name: 'maintenanceManage',
      menuName: '保养管理',
      component: () => import('@/views/system/maintenanceManage'),
      meta: { title: 'maintenanceManage', icon: 'user', iconType: 'svg' }
    },
    {
      path: 'pdpa',
      name: 'pdpa',
      menuName: 'PDPA管理',
      component: () => import('@/views/system/pdpa'),
      meta: { title: 'pdpa', icon: 'user', iconType: 'svg' }
    }
  ]
}